<template>
    <div class="s-professionalInfoConsultationAdvisoryDetails-container">
        <topNav></topNav>
        <div class="topBg">
          <div class="banner w1300 marginAuto"></div>
        </div>
        <div class="content w1300 marginAuto">
            <div class="crumbs">
                <img src="../assets/image/index/home.png" class="img" alt />
                <span @click="crumbsGoRoute('index')" class="go">首页&gt;</span>
                <span @click="crumbsGoRoute('dealmakers')" class="go">交易撮合&gt;</span>
                <span>详情</span>
            </div>
            <div class="expert-introduction-wrap">
                <div class="expert-baseinfo-imglist">
                  <el-image v-for="(item,index) in imgList" :key="index" :src="item" :preview-src-list="imgList"
                    class="expert-baseinfo-img">
                  </el-image>
                </div>
                <div class="expert-baseinfo-wrap">
                  <el-row>
                    <el-col :span="24">
                      <span class="title red">{{ matchUpDetailsData.matchUpType ? matchUpDetailsData.matchUpType : "--"
                      }}</span>
                      <span class="title margin_left">{{ matchUpDetailsData.transactionTitle ? matchUpDetailsData.transactionTitle
                      : "--" }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span class="column_span">发布人：{{ matchUpDetailsData.contacts ? matchUpDetailsData.contacts : "--" }}</span>
                      <span class="column_span margin_left">发布日期：{{ matchUpDetailsData.transactionDate ?
                      matchUpDetailsData.transactionDate : "--" }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-card class="box-card">
                        <el-row>
                          <el-col :span="2" style="height: 10px">

                          </el-col>
                          <el-col :span="10">
                            <span class="column_span column_bold">交易类型：{{ matchUpDetailsData.transactionType ?
                            matchUpDetailsData.transactionType : "--" }}</span>
                          </el-col>

                          <el-col :span="10">
                            <span class="column_span column_bold">产品类型：{{ matchUpDetailsData.matchUpType ?
                            matchUpDetailsData.matchUpType : "--" }}</span>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="2" style="height: 10px">

                          </el-col>
                          <el-col :span="10">
                            <span class="column_span column_bold">价格：<span class="column_span column_bold red">{{
                            matchUpDetailsData.transactionPrice ? matchUpDetailsData.transactionPrice :"--" }}</span>
                              {{matchUpDetailsData.priceUnit}}</span>
                          </el-col>
                          <el-col :span="10">
                            <span class="column_span column_bold">数量：<span class="column_span column_bold red">{{
                            matchUpDetailsData.transactionNumber ? matchUpDetailsData.transactionNumber : "--" }}
                              </span>{{matchUpDetailsData.numberUnit}}</span>
                          </el-col>
<!--                          <el-col :span="8">-->
<!--                          </el-col>-->
                        </el-row>
                      </el-card>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span class="column_span">交易地区：{{ address ? address : "--" }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span class="column_span">详细地址：{{ matchUpDetailsData.address ? matchUpDetailsData.address : "--" }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span class="column_span">发布人：{{ matchUpDetailsData.contacts ? matchUpDetailsData.contacts : "--" }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span class="column_span">物流公司：{{ matchUpDetailsData.logisticsCompany ? matchUpDetailsData.logisticsCompany : "--" }}</span>
                      <el-button size="mini" class="loginBtn" style="margin-left: 5px;" @click="logisticsCompanyBtn">物流查询</el-button>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span class="column_span">
                        联系电话：
                        <span v-if="isShowPhone">
                          {{matchUpDetailsData.contactsPhone ? matchUpDetailsData.contactsPhone : "--"}}
                        </span>
                        <span v-else>
                          {{ hidePhone }}
                          <el-button size="mini" class="loginBtn" @click="login">登录后查看
                          </el-button>
                        </span>
                      </span>
                    </el-col>
                  </el-row>
                  <!-- <div class="transactions-release-body">

                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">标题：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.transactionTitle ? matchUpDetailsData.transactionTitle :"--" }}
                      </div>
                    </div>

                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">撮合类型：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.matchUpType ? matchUpDetailsData.matchUpType :"--" }}
                      </div>
                    </div>

                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">地区：</span>
                      <div class="dealmakersDetails_content">

                          <el-select
                              v-model="matchUpDetailsData.pronince"
                              placeholder="请选择"
                              class="region_select"
                              disabled
                              @change="selectListRegion($event,'市')"
                          >
                            <el-option
                                v-for="item in provinceData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                          </el-select>

                          <el-select
                              v-model="matchUpDetailsData.city"
                              placeholder="请选择"
                              class="region_select"
                              disabled
                              @change="selectListRegion($event,'县')"
                          >
                            <el-option
                                v-for="item in cityData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                          </el-select>

                          <el-select v-model="matchUpDetailsData.county"
                                     placeholder="请选择"
                                     disabled
                                     class="region_select">
                            <el-option
                                v-for="item in countyData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                          </el-select>

                      </div>
                    </div>

                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">撮合产品：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.matchUpName ? matchUpDetailsData.matchUpName :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">详细地址：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.address ? matchUpDetailsData.address :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">产品品种：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.matchUpVarieties ? matchUpDetailsData.matchUpVarieties :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">发布人：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.contacts ? matchUpDetailsData.contacts :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">数量：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.transactionNumber ? matchUpDetailsData.transactionNumber :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">联系电话：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.contactsPhone ? matchUpDetailsData.contactsPhone :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">价格：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.transactionPrice ? matchUpDetailsData.transactionPrice :"--" }}元/公斤
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">日期：</span>
                      <div class="dealmakersDetails_content">
                        {{ matchUpDetailsData.transactionDate ? matchUpDetailsData.transactionDate :"--" }}
                      </div>
                    </div>
                    <div class="dealmakersDetails_item">
                      <span class="dealmakersDetails_label">图片：</span>
                      <div class="dealmakersDetails_content">
                        <img
                            v-if="matchUpDetailsData.img"
                            :src="imgURL+'/'+matchUpDetailsData.img"
                            class="avatar"
                        />
                      </div>
                    </div>

                  </div> -->
                </div>
            </div>

        </div>
        <footer-nav></footer-nav>

    </div>
</template>

<script>
  import topNav from "../components/topNav.vue";
  import footerNav from "../components/footerNav.vue";
  import {matchUpGetById, selectListRegion} from "@/utils/api/dealmakers";
  import eventBus from "../utils/js/eventBus.js";
  import Vue from "vue";
  export default {
    name: "dealmakersDetails",
    data() {
      return {
        matchUpDetailsData: {
          transactionTitle: "", // 标题
          matchUpType: "", // 撮合类型
          matchUpName: "", // 撮合产品
          matchUpVarieties: "", // 产品品种
          contacts: "", // 发布人
          contactsPhone: "", // 联系电话
          transactionNumber: "", // 数量
          img: "", // 图片
          transactionPrice: "", // 价格
          transactionDate: "", // 交易日期
          pronince: "",
          city: "",
          county: "",
          address: "" // 详细地址
        },
        imgList: [],
        address: "",
        isShowPhone: null,
        provinceData: [], // 省数据
        cityData: [], // 市数据
        countyData: [], // 区数据
      };
    },
    components: { topNav, footerNav },
    mounted(){
      if(this.$route.query.id){
        this.id = this.$route.query.id;
      }
      this.isShowPhone = localStorage.getItem("token") == null ? false : true;
      this.getMatchUpGetById()
      // this.selectListRegion(0, "省");
  },
  computed: {
    hidePhone: function () {
      const newarr = this.matchUpDetailsData.contactsPhone.split('');
      newarr.forEach((item, index, arr) => {
        if (index > 2 && index < 7) {
          arr[index] = '*'
        }
      })
      return newarr.join('');
    }
  },
    methods: {
      // 省市区联动
      async selectListRegion(pid, name) {
        let res = await selectListRegion({
          orderBy: { id: "asc" },
          pid
        });
        if (res.data.code == 0) {
          if (name == "省") {
            this.provinceData = res.data.data;
            this.selectListRegion(this.provinceData[0].id, "市");
          }
          if (name == "市") {
            this.cityData = res.data.data;
            this.matchUpDetailsData.city = "";
            this.matchUpDetailsData.county = "";

            if(this.matchUpDetailsData.city !=''){
              this.selectListRegion(this.matchUpDetailsData.city, "县");
            }else{
              this.selectListRegion(this.cityData[0].id, "县");
            }
            if(this.matchUpDetailsData.city != ""){
              this.selectListRegion(this.matchUpDetailsData.city, "县");
            }else{
              this.selectListRegion(this.cityData[0].id, "县");
            }
            this.matchUpDetailsData.city = "";
            this.matchUpDetailsData.county = "";
          }
          if (name == "县") {
            this.matchUpDetailsData.county = "";
            this.countyData = res.data.data;
          }
        }
      },
      async getMatchUpGetById(id){
        let res = await matchUpGetById({id: this.id});
        if(res.data.code == 0){
          //this.selectListRegion(res.data.data.pronince,'市')
          //this.selectListRegion(res.data.data.city,'县')
          // setTimeout(function(){
          this.matchUpDetailsData = res.data.data;
          console.log('*********************this.matchUpDetailsData',this.matchUpDetailsData)
          // 图片
          if (this.matchUpDetailsData.img) {
            this.imgList = this.matchUpDetailsData.img.split(",");
          }
          if (this.imgList.length < 1) {
            this.imgList.push("#");
          } else {
            this.imgList = this.imgList.map((item, index) => {
              if(item.indexOf('http') == -1){
                return this.imgURL + '/' + item;
              }
              return item;
            })
          }
          // 地址
          this.address = (this.matchUpDetailsData.proninceValue ? this.matchUpDetailsData.proninceValue + "-" : "")
            + (this.matchUpDetailsData.cityValue ? this.matchUpDetailsData.cityValue + "-" : "")
            + (this.matchUpDetailsData.countyValue ? this.matchUpDetailsData.countyValue : "");
          if (this.address === "") {
            this.address = "--";
          }
          // },2500)

        }
      },
      login() {
        //TODO 此处弹出登录和注册框
        eventBus.$emit("loginClick", true, '登录');
      },
      crumbsGoRoute(path) {
        this.$router.push({ path });
      },
      //物流查询
      logisticsCompanyBtn(){
        window.location.href = "https://www.baidu.com/s?word=%E5%BF%AB%E9%80%92%E6%9F%A5%E8%AF%A2&tn=site888_2_pg&ch=3&lm=-1&ssl_s=2&ssl_c=ssl1_18a2ab7623b&ie=utf-8";
      }
    }
  };
</script>

<style lang="scss" scoped>
@import "../utils/css/common.scss";
@import "../utils/css/dealmakersDetails.scss";

    // .transactions-release-body {
    //   height: 550px;
    //   .transactions-form-item {
    //     width: 35%;
    //     float: left;
    //     margin-right: 15%;
    //   }
    //   .dealmakersDetails_item{
    //     width: 50%;
    //     float: left;
    //     display: flex;
    //     justify-content: flex-start;
    //     //margin-left: 10%;
    //     height: 60px;
    //     line-height: 60px;
    //     .dealmakersDetails_label{
    //       text-align: right;
    //       vertical-align: middle;
    //       float: left;
    //       font-size: 16px;
    //       color: #606266;
    //       padding: 0 12px 0 0;
    //       width: 100px;
    //     }
    //     .dealmakersDetails_content{
    //       text-align: right;
    //       vertical-align: middle;
    //       font-size: 16px;
    //       color: #606266;
    //       .region_select{
    //         width: 150px;
    //         margin-right: 10px;
    //       }
    //     }
    //   }

    // }
    // .transactions-form-regon {
    //   .el-select {
    //     width: 98%;
    //   }
    // }
    // .transactions-release-footer {
    //   display: flex;
    //   justify-content: center;
    //   .transactions-release-close {
    //     width: 129px;
    //     height: 35px;
    //     border: 1px solid #54ae49;
    //     background: #fff;
    //     border-radius: 6px;
    //     font-size: 18px;
    //     font-family: PingFangSC;
    //     font-weight: 400;
    //     color: #28bd4e;
    //     line-height: 35px;
    //     text-align: center;
    //     cursor: pointer;
    //   }
    //   .transactions-release-sure {
    //     width: 129px;
    //     height: 35px;
    //     border: 1px solid #54ae49;
    //     background: linear-gradient(90deg, #1cba4d, #a1dc61);
    //     border-radius: 6px;
    //     font-size: 18px;
    //     font-family: PingFangSC;
    //     font-weight: 400;
    //     color: #ffffff;
    //     line-height: 35px;
    //     text-align: center;
    //     margin-left: 100px;
    //     cursor: pointer;
    //   }
    // }


    // .avatar-uploader .el-upload {
    //   border: 1px dashed #d9d9d9;
    //   border-radius: 6px;
    //   cursor: pointer;
    //   position: relative;
    //   overflow: hidden;
    // }
    // .avatar-uploader .el-upload:hover {
    //   border-color: #409eff;
    // }
    // .avatar-uploader-icon {
    //   font-size: 28px;
    //   color: #8c939d;
    //   width: 155px;
    //   height: 155px;
    //   line-height: 155px;
    //   text-align: center;
    //   border: 1px solid #e5e5e5;
    // }
    // .avatar {
    //   width: 240px;
    //   height: 170px;
    //   display: block;
    //   margin-top: 20px;
    // }
</style>
